import React from "react";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import FormOperator from "./FormOperator";
import AssociateTableUser from "./AssociateTableUser";
import { useGetCommercialistaIdQuery } from "../../api/admin/gestisciCommercialistiApi";
import { useTranslation } from "react-i18next";

const SchedaOperator = ({
  operator,
  saveCommercialista,
  deleteCommercialista,
  onClose,
  isLoadingSave,
}) => {
  const { t } = useTranslation();
  const { data, isLoading: isLoadingCommercialisti } =
    useGetCommercialistaIdQuery(operator.Id);

  const isValidationOperator = data && data?.Data;

  return (
    <>
      {isLoadingCommercialisti && !isValidationOperator ? (
        <CoreSpinner />
      ) : (
        <div className="flex-row">
          <div>
            <h2 className="text-center">{`${t("Card")} ${t("operator")}`}</h2>
          </div>
          <div className="flex space-x-8">
            <div className="w-6/12">
              <FormOperator
                operatorData={data}
                saveCommercialista={saveCommercialista}
                deleteCommercialista={deleteCommercialista}
                onClose={onClose}
                isLoadingSave={isLoadingSave}
              />
            </div>
            <div className="w-6/12">
              <AssociateTableUser
                operatorData={data}
                isLoadingCommercialisti={isLoadingCommercialisti}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SchedaOperator;
